import { render, staticRenderFns } from "./VisualizarBiometria.vue?vue&type=template&id=573b1c7e&scoped=true&"
import script from "./VisualizarBiometria.vue?vue&type=script&lang=js&"
export * from "./VisualizarBiometria.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarBiometria.vue?vue&type=style&index=0&id=573b1c7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b1c7e",
  null
  
)

export default component.exports